// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

export const SET_NOTIFICATION_LIST = 'notification/SET_NOTIFICATION_LIST';
export const ADD_NOTIFICATION_ITEM = 'notification/ADD_NOTIFICATION_ITEM';
export const REMOVE_NOTIFICATION_ITEM = 'notification/REMOVE_NOTIFICATION_ITEM';
export const CLEAR_NOTIFICATION_LIST = 'notification/CLEAR_NOTIFICATION_LIST';
export const APPEND_NOTIFICATIONS = 'notification/APPEND_NOTIFICATIONS';
